// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"2150ae70","37":"cf2b42e9","49":"cecb4328","296":"17e9c719","398":"0976acfe","556":"d198ba84","760":"8f790683","951":"0dd6a874","995":"e3e8599d"}[chunkId] + ".chunk.js";
};